import { Tooltip, TooltipProps, TypographyProps, Typography } from "@mui/material";
import { useOverflow } from "../../hooks";
import React from "react";

type UseOverflowTextProps = {
	children: React.ReactNode;
	disabled?: boolean;
	tooltipProps?: Omit<TooltipProps, "title" | "disableHoverListener" | "children">;
} & Omit<TypographyProps, "children" | "ref">;

/**Wraps text in a tooltip. Tooltip will only show on overflow.
 * It's lighter than EllipsisTooltip and will show ... on the text if too long */
export default function OverflowText({ children, disabled, tooltipProps, ...props }: UseOverflowTextProps) {
	const [textRef, isTextOverflowed] = useOverflow({ subtree: false, attributes: false });

	const content = (
		<Typography
			{...props}
			ref={textRef}
			sx={{
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				display: "block",
				...props.sx,
			}}
		>
			{children}
		</Typography>
	);

	if (!isTextOverflowed || disabled) {
		return content;
	}

	return (
		<Tooltip
			{...tooltipProps}
			title={children}
			disableHoverListener={!isTextOverflowed}
			slotProps={{ popper: { modifiers: [{ name: "flip", enabled: false }] }, ...tooltipProps?.slotProps }}
		>
			{content}
		</Tooltip>
	);
}
